import Quill from 'quill'

const BaseLink = Quill.import('formats/link')

export default class Link extends BaseLink {
  static create (value) {
    let node = BaseLink.create(value)
    value = BaseLink.sanitize(value)
    node.setAttribute('href', value)
    if (value.startsWith(window.location.origin)) {
      node.removeAttribute('target')
    } else {
      node.setAttribute('target', '_blank')
    }
    return node
  }

  format (name, value) {
    super.format(name, value)

    if (name !== this.statics.blotName || !value) {
      return
    }

    if (value.startsWith(window.location.origin)) {
      this.domNode.removeAttribute('target')
    } else {
      this.domNode.setAttribute('target', '_blank')
    }
  }
}



// WEBPACK FOOTER //
// ./src/macarons/quill/Link.js